export interface AvailableDatesResult {
  dates: string[];
}

export class AvailableDates {
  dates: Date[];
  disabledDates: Date[];
  startDate: Date;
  endDate: Date;

  constructor(resp: AvailableDatesResult) {
    this.dates = resp.dates.map((d) => new Date(d));
    this.disabledDates = getDisabledDates(this.dates);
    this.startDate = this.dates[0];
    this.endDate = this.dates[this.dates.length - 1];
  }
}

const getDisabledDates = (dates: Date[]) => {
  const disabledDates = [];

  // Sort the dates in ascending order
  const sortedDates = dates.sort((a, b) => a.getTime() - b.getTime());

  // Iterate over the sorted dates to find the missing ones
  for (let i = 0; i < sortedDates.length - 1; i++) {
    const currentDate = new Date(sortedDates[i]);
    const nextDate = new Date(sortedDates[i + 1]);

    // Move to the next date in the sequence
    currentDate.setDate(currentDate.getDate() + 1);

    // Check if there are missing dates between the current and next date
    while (currentDate < nextDate) {
      disabledDates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
  }
  
  return disabledDates;
};
